import { ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthSessionService } from '@/core/services/auth-session.service';
import { WebsocketService } from '@/core/services/websocket/websocket.service';
import { notificationFromWebsocket } from './notification-from-websocket';

const NOTIFICATION_TOAST_MS = 10000;

@Component({
  selector: 'app-message-notifications',
  standalone: true,
  templateUrl: './message-notifications.component.html',
  styleUrl: './message-notifications.component.scss',
})
export class MessageNotificationsComponent implements OnInit {
  private readonly websocket = inject(WebsocketService);
  private readonly authSession = inject(AuthSessionService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  wsToasts: Array<{ title: string; body: string }> = [];
  private readonly shownKeys = new Set<string>();

  ngOnInit(): void {
    const token = this.authSession.getToken();
    if (token) {
      this.websocket.connect(token);
    }

    this.websocket.notificationEvents$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      this.showWsToast(notificationFromWebsocket(event));
    });
  }

  removeWsToast($event: Event, index: number): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.wsToasts.splice(index, 1);
    this.cdr.detectChanges();
  }

  private showWsToast(toast: { title: string; body: string } | null): void {
    if (!toast) {
      return;
    }
    const key = `ws:${toast.title}:${toast.body}`;
    if (this.shownKeys.has(key)) {
      return;
    }
    this.shownKeys.add(key);
    this.wsToasts.unshift(toast);
    this.cdr.detectChanges();
    setTimeout(() => {
      const idx = this.wsToasts.indexOf(toast);
      if (idx !== -1) {
        this.wsToasts.splice(idx, 1);
        this.cdr.detectChanges();
      }
      this.shownKeys.delete(key);
    }, NOTIFICATION_TOAST_MS);
  }
}
